module.exports = "/images/sala_viajero_z03.jpg?cff86497b03ac601a7580c9dffc46724";